import(/* webpackMode: "eager" */ "/codebuild/output/src3612898653/src/easymeat-web/src/app/ez-pay/page.tsx");
